module.exports = __webpack_public_path__ + "static/media/search.464a8e34.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/search.svg
// module id = 247
// module chunks = 0